'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _icarusForms = require('icarus-forms');

var _icarusForms2 = _interopRequireDefault(_icarusForms);

var _storage = require('./storage');

var _attribution = require('./attribution');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var merge = require('lodash/merge');

// set the core tracking params in the given form, including the trackedLandingTimestamp and trackedLandingPage
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable import/no-unresolved */
/* eslint-disable global-require */
/* eslint-disable no-unused-expressions */

var setFormTrackingParams = function setFormTrackingParams($form) {
    $form.find('input[name="tracked_landing_page"]').val(_storage.Storage.get('MMLandingURL') || document.location.href);
    $form.find('input[name="conversion_page"]').val(document.location.href);

    var setLandingTimestamp = function setLandingTimestamp() {
        $form.find('input[name="tracked_landing_timestamp"]').val(_storage.Storage.get('MMLandingTimestamp'));
    };

    // when no SSI variable is available for timestamp, we fetch it async, so its possible it isnt yet available
    !_storage.Storage.get('MMLandingTimestamp') ? setTimeout(setLandingTimestamp, 500) : setLandingTimestamp();

    // when a tracker is unable to be loaded for the GA client, an error will be thrown.
    // We don't want that bubbling here
    try {
        (0, _attribution.getClientId)().then(function (clientId) {
            return $form.find('input[name="ga_client_id"]').val(clientId);
        });
    } catch (err) {
        console.warn('got error ' + err.toString() + ' getting GA client ID');
    }
};

// for case parameters (e.g. litigation, case type), set the appropriate fields on the form (if the page values are set)
var setFormCaseParams = function setFormCaseParams($form) {
    if (!(window.MMShared && window.MMShared.Vars && window.MMShared.Vars.attribution)) {
        return false;
    }

    var _window$MMShared$Vars = window.MMShared.Vars.attribution,
        litigation = _window$MMShared$Vars.litigation,
        caseType = _window$MMShared$Vars.caseType,
        marketingSubSource = _window$MMShared$Vars.marketingSubSource;


    if (litigation) $form.find('input[name="litigation"]').val(litigation);
    if (caseType) $form.find('input[name="case_type"]').val(caseType);
    if (marketingSubSource) $form.find('input[name="marketing_sub_source"]').val(marketingSubSource);

    return true;
};

var onFormReady = function onFormReady($form) {
    setFormTrackingParams($form);
    setFormCaseParams($form);
};

var createHubspotForm = function createHubspotForm(target) {
    var extra = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var portalId = '1841598';
    var formId = extra.formId;


    console.log('creating HS form with ID ' + formId);

    var createForm = function createForm() {
        window.hbspt.forms.create({
            portalId: portalId,
            target: target,
            formId: formId,
            onFormReady: onFormReady,
            onFormSubmit: function onFormSubmit($form) {
                _storage.Storage.remove('MMLandingURL');
                _storage.Storage.remove('MMLandingTimestamp');

                $form.find('input, textarea').each(function () {
                    var el = $(undefined).get(0);

                    $(undefined).val($(undefined).val().replace(/\n|\r/g, ' '));
                    el.defaultValue = el.defaultValue.replace(/\n|\r/g, ' ');
                });
            }
        });
    };

    var loadHSLib = function loadHSLib() {
        var script = document.createElement('script');
        script.src = '//js.hsforms.net/forms/v2.js';
        script.onload = createForm;

        var body = document.getElementsByTagName('body')[0];
        body.appendChild(script);
    };

    if (!window.hbspt) console.warn('HS not loaded');

    var action = window.hbspt ? createForm : loadHSLib;

    action();

    return true;
};

var createIcarusForm = function createIcarusForm(container) {
    var extra = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    /* eslint-disable prefer-const */
    var listeners = extra.listeners,
        props = (0, _objectWithoutProperties3.default)(extra, ['listeners']);

    listeners = listeners || {};

    var onRendered = function onRendered(formEl) {
        if (listeners.onRendered) listeners.onRendered(formEl);

        onFormReady($(formEl));
    };

    var onSubmit = function onSubmit(fieldsData) {
        _storage.Storage.remove('MMLandingURL');
        _storage.Storage.remove('MMLandingTimestamp');

        fieldsData.forEach(function (datField) {
            if (Object.prototype.hasOwnProperty.call(datField, 'value') && typeof datField.value === 'string') {
                /* eslint-disable no-param-reassign */
                datField.value = datField.value.replace(/\n|\r/g, ' ');
                /* eslint-disable no-param-reassign */
            }
        });

        var submitForm = true;

        if (listeners.onSubmit) submitForm = listeners.onSubmit(fieldsData);

        return submitForm;
    };

    var defaults = {
        apollo: 'https://apollo.forthepeople.com',
        // TODO this needs to be smarter
        themesLocation: 'https://static.forthepeople.com/engineering/icarus/v1.11-latest/themes',
        listeners: merge({}, listeners, { onRendered: onRendered, onSubmit: onSubmit })
    };

    var options = merge({}, defaults, props);

    return new _icarusForms2.default(container, options);
};

var createForm = function createForm(container) {
    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var _createForm = opts.forceHubspot ? createHubspotForm : createIcarusForm;
    return _createForm(container, opts);
};

/**
 * a proxy to createForm which provides an escape hatch to use an emergency Hubspot form when a window variable is set
 * @param container
 * @param opts
 */
var createFormWithEscape = function createFormWithEscape(container) {
    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var escapeFormId = opts.escapeFormId || '13d5e5aa-85d4-4870-8b14-7a2f05b071ed'; // ID of HS escape form

    var escapedOpts = merge({}, opts, { forceHubspot: opts.forceHubspot || window.MM && window.MM.forceHubspot });
    escapedOpts = merge({}, escapedOpts, { formId: escapedOpts.forceHubspot ? escapeFormId : opts.formId });

    return createForm(container, escapedOpts);
};

exports.default = createFormWithEscape;


//////////////////
// WEBPACK FOOTER
// ./~/@morgan-morgan/core/module/lib/forms.js
// module id = 190
// module chunks = 2 3